import { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ProfileSurveyType } from "../../../model/datatype";
import Moment from "moment";
import "moment/locale/th";
import { useTranslation } from "react-i18next";
import { appConfig } from "../../../authConfig";
import { useUserProfile } from "../../../contexts/UserProfileContext";

export const ProfileUniformSurvey = (props: any) => {
  const { profile, loading: profileLoading } = useUserProfile();
  const [UserProfilePic, setUserProfilePic] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  if (typeof process.env.REACT_APP_NAME === "string") {
    document.title = process.env.REACT_APP_NAME;
  }

  if (localStorage.getItem("Language") === "en") {
    Moment.locale("en-sg");
  } else {
    Moment.locale("th");
  }
  const { t, i18n } = useTranslation();
  const changeLanguageTh = (th: any) => {
    i18n.changeLanguage(th);
    localStorage.setItem("Language", "th");
  };

  const changeLanguageEn = (en: any) => {
    i18n.changeLanguage(en);
    localStorage.setItem("Language", "en");
  };

  const [data, setData] = useState<ProfileSurveyType | null>(null);

  // const profile: any = JSON.parse(lgProfile)

  // const { instance } = useMsal();
  useEffect(() => {
    const userPhoto = sessionStorage.getItem("userPhoto");
    console.log(
      "🖼️ ProfileUniformSurvey: Getting userPhoto from sessionStorage:",
      userPhoto ? "exists" : "null"
    );
    //console.log("🔍 ProfileUniformSurvey: userPhoto value:", userPhoto);

    // ตรวจสอบว่ามีรูปโปรไฟล์หรือไม่ (ไม่เป็น null และไม่เป็น empty string และเป็น base64 image)
    if (userPhoto && userPhoto !== "" && userPhoto.startsWith("data:image")) {
      console.log(
        "✅ ProfileUniformSurvey: Using user photo from sessionStorage"
      );
      setUserProfilePic(userPhoto);
    } else {
      console.log(
        "🚫 ProfileUniformSurvey: No valid user photo, using default"
      );
      setUserProfilePic("../images/icon/logo.png");
    }

    if (!profileLoading && profile) {
      setIsLoading(false);
      setData(profile);
    }
  }, [profileLoading, profile]);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    setTimeout(() => {
      window.location.href =
        "https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=" +
        appConfig.appEndpoint.baseUrl;
    }, 1000);
  };
  const getTextStyle = () => ({
    filter: isLoading ? "blur(3px)" : "none",
    transition: "filter 0.5s ease-in-out",
  });

  return (
    <>
      <div className="fix-box-header ">
        <Container fluid className="header-bg">
          <Row>
            <Col xs={6}>
              <h4 className="hello mt-3">HR Mobile </h4>
              <h4 className="welcome">
                {t("greet")}{" "}
                {process.env.REACT_APP_ENV
                  ? "(" + process.env.REACT_APP_ENV + ")"
                  : ""}
              </h4>
            </Col>
            <Col
              xs={6}
              className="d-flex justify-content-end align-content-end mt-3"
            >
              <div className="switch-language d-flex justify-content-end">
                <span
                  className="p-1 pr-2"
                  onClick={() => changeLanguageTh("th")}
                >
                  <img
                    src="../images/th.svg"
                    alt="logo th"
                    width={25}
                    className={`${
                      localStorage.getItem("Language") === "th" ? "active" : ""
                    }`}
                  />
                  <p
                    className={`title + ${
                      localStorage.getItem("Language") === "th" ? "active" : ""
                    }`}
                  >
                    TH
                  </p>
                </span>
                <span className="p-1" onClick={() => changeLanguageEn("en")}>
                  <img
                    src="../images/en.svg"
                    alt="logo en"
                    width={25}
                    className={`${
                      localStorage.getItem("Language") === "en" ? "active" : ""
                    }`}
                  />
                  <p
                    className={`title + ${
                      localStorage.getItem("Language") === "en" ? "active" : ""
                    }`}
                  >
                    EN
                  </p>
                </span>
                <span className="p-1 ml-2" style={{ width: "80px" }}>
                  <div
                    className="icon-logout text-center"
                    onClick={() => handleLogout()}
                  >
                    <img
                      className="btn-login"
                      src="../images/icon-logout.svg"
                      width={25}
                      alt="logout"
                    />
                    <p className="text-logout">{t("logout_text")}</p>
                  </div>
                </span>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="profile-line-hr-box pb-3 ">
          <div className="time-detail-box mt-0 mb-0">
            <Container>
              <Row>
                <Col>
                  <div className="user-images">
                    <input
                      type="image"
                      className="img"
                      src={`${UserProfilePic}`}
                      alt="user profile photo"
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="my-2">
                  <h3
                    className="profile-name font-weight-bold"
                    style={getTextStyle()}
                  >
                    {t("uniform_survey.personal_information.title")}
                  </h3>
                </Col>
              </Row>
              <Row>
                <Col className="mb-2">
                  <div className="personal-title" style={getTextStyle()}>
                    {t("uniform_survey.personal_information.employee_id")}
                  </div>
                  <div className="personal-detail" style={getTextStyle()}>
                    {data?.employeeId}
                  </div>
                </Col>
                <Col className="mb-2">
                  <div className="personal-title" style={getTextStyle()}>
                    {t("uniform_survey.personal_information.employee_name")}
                  </div>
                  <div className="personal-detail" style={getTextStyle()}>
                    {localStorage.getItem("Language") === "en"
                      ? data?.employeeNameEn
                      : data?.employeeNameTh}
                  </div>
                </Col>
              </Row>
              {/* <Row>
                                <Col className="mb-2">
                                    <div className="personal-title">{t('uniform_survey.personal_information.gender')}</div>
                                    <div className="personal-detail">{data?.gender}</div>
                                </Col>
                                <Col className="mb-2">
                                    <div className="personal-title">{t('uniform_survey.personal_information.phone_number')}</div>
                                    <div className="personal-detail">{data?.mobileNo}</div>
                                </Col>
                            </Row> */}
              <Row>
                <Col className="mb-2">
                  <div className="personal-title" style={getTextStyle()}>
                    {t("uniform_survey.personal_information.department")}
                  </div>
                  <div className="personal-detail" style={getTextStyle()}>
                    {data?.department}
                  </div>
                </Col>
                <Col className="mb-2">
                  <div className="personal-title" style={getTextStyle()}>
                    {t("uniform_survey.personal_information.job_title")}
                  </div>
                  <div className="personal-detail" style={getTextStyle()}>
                    {data?.position}
                  </div>
                </Col>
              </Row>
              {/* <Row>
                            <Col>
                                <div className="personal-title">Email</div>
                                <div className="personal-detail">{profile?.}</div>
                            </Col>
                            <Col>
                            </Col>
                        </Row> */}
            </Container>
          </div>
        </div>
      </div>
    </>
  );
};
